import { Input, OnChanges, SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html'
})
export class ProgressBarComponent implements OnInit {
  @Input('currentStep') currentStep: string;
  @Input('steps') steps: string[] = [];

  constructor() {}

  ngOnInit(): void {}

  public get percentage(): number {
    return (
      (this.steps.indexOf(this.currentStep) / (this.steps.length - 1)) * 100
    );
  }
}
